import {
  CRAWLED_URL,
  CHAT_LOADING,
  TOGGLE_LOADING,
  CRAWL_LOADING,
  URL_LISTING,
  UNAUTHORIZED_CHAT_AI,
  FETCH_EXTERNAL_ASSET_LISTING,
  UPDATED_PROMPT_LIST,
  TEXT_LISTING,
  UPLOAD_LOADING,
  PAGINATION_COUNT,
  API_CALL_HIDER,
  GREETING_MESSAGE_DATA,
  SET_DROPDOWN_DATA,
  ENGAGE_LISTING,
  EDIT_ENGAGE_DATA,
  OPERATION_MODE,
  EDIT_ENGAGE_MEETING_DATA,
  URL_PROCESSING,
  FETCH_INTERNAL_ASSET_LISTING,
  CHAT_DESIGN_DATA,
  FETCH_GREETING_DATA,
  CHAT_DESIGN_SCREENSHOT,
  FETCH_LEAD_LISTING,
  FETCH_CORRECTION_LISTING,
  FETCH_INPUTS_LISTING,
  ONBOARDING_DATA,
  TOKEN_DATA,
  T_DATA
  } from "../../constants/ChatAiActionTypes";


  const initialState = {
    loading: false,
    greeting_data: null,
    crawlLoading: false,
    unAuthorisedChatAi: null,
    crawledUrl: null,
    urlListing: null,
    engage_listing: null,
    lead_listing_data: null,
    textListing: null,
    url_processing: false,
    engage_drop_down: null,
    external_asset_list: null,
    internal_asset_list: null,
    chat_loading: false,
    upload_loading: false,
    edit_engage: null,
    operation_mode: false,
    prompt_list: null,
    paginationCount: 1,
    apiCallHider: "",
    meeting_engage: null,
    greeting_message: null,
    chatDesignData: null,
    designScreenshot: null,
    correction_listing: null,
    input_listing: null,
    onboardingData:null,
    tokenData:null,
    tData:null,
  }

  const chatAiReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case TOGGLE_LOADING:
        return { ...state, loading: payload };
      case UPLOAD_LOADING:
        return { ...state, upload_loading: payload };
      case CHAT_LOADING:
        return { ...state, chat_loading: payload };
      case CRAWL_LOADING:
        return { ...state, crawlLoading: payload };
      case CRAWLED_URL:
        return { ...state, crawledUrl: payload };
      case URL_PROCESSING:
        return { ...state, url_processing: payload };
      case FETCH_GREETING_DATA:
        return { ...state, greeting_data: payload };
      case OPERATION_MODE:
        return { ...state, operation_mode: payload };
      case EDIT_ENGAGE_DATA:
        return { ...state, edit_engage: payload };
      case EDIT_ENGAGE_MEETING_DATA:
        return { ...state, meeting_engage: payload };
      case URL_LISTING:
        return { ...state, urlListing: payload };
      case ENGAGE_LISTING:
        return { ...state, engage_listing: payload };
      case FETCH_LEAD_LISTING:
        return { ...state, lead_listing_data: payload };
      case API_CALL_HIDER:
        return { ...state, apiCallHider: payload };
      case PAGINATION_COUNT:
        return { ...state, paginationCount: payload };
      case GREETING_MESSAGE_DATA:
        return { ...state, greeting_message: payload };
      case SET_DROPDOWN_DATA:
        return { ...state, engage_drop_down: payload };
      case UNAUTHORIZED_CHAT_AI:
        return { ...state, unAuthorisedChatAi: payload };
      case FETCH_EXTERNAL_ASSET_LISTING:
        return { ...state, external_asset_list: payload };
      case TEXT_LISTING:
        return { ...state, textListing: payload };
      case FETCH_INTERNAL_ASSET_LISTING:
        return { ...state, internal_asset_list: payload };
      case UPDATED_PROMPT_LIST:
        return { ...state, prompt_list: payload };
      case CHAT_DESIGN_DATA:
        return { ...state, designData: payload };
      case CHAT_DESIGN_SCREENSHOT:
        return { ...state, designScreenshot: payload };
      case FETCH_INPUTS_LISTING:
        return { ...state, input_listing: payload };
      case FETCH_CORRECTION_LISTING:
        return { ...state, correction_listing: payload };
      case ONBOARDING_DATA:
        return { ...state, onboardingData: payload };
      case TOKEN_DATA:
        return { ...state, tokenData: payload };
      case T_DATA:
        return { ...state, tData: payload };
      default:
        return state;
    }
  };

  export default chatAiReducer;
